<div *ngIf="open" class="closable-container" [class.warning]="variant === 'warning'" role="alert">
  <button mat-icon-button class="close-button" (click)="closePanel()">
    <mat-icon>close</mat-icon>
  </button>

  <ng-content></ng-content>
</div>
